<template>
  <v-card flat>
    <v-card-text>
      <v-card width="40%">
        <v-text-field
          v-model="url"
          label="URL with maps"
          :append-icon="mdiSend"
          filled
          v-validate="{
            required: true
          }"
          name="url"
          :loading="loading"
          :error-messages="errors.collect('url')"
          @keyup.enter="send"
          @click:append="send"
        />
      </v-card>
      <v-card
        v-for="(map, mapIndex) in maps"
        :key="map.title"
        dark
        class="mt-3 pa-3"
      >
        <div>
          <h3>{{ map.title }}</h3>
          <div class="d-flex align-center">
            1px equal
            <v-text-field
              v-model="map.cmPerPixel"
              type="number"
              class="mt-0 ml-2"
              :style="{
                maxWidth: '50px'
              }"
              dense
              hide-details
            />
            cm
          </div>
          <span>Area: {{ getAreaInMeters(map) }} m<sup>2</sup></span>
        </div>
        <div
          :style="{
            height: map.height
          }"
          class="map"
        >
          <svg
            :height="map.height"
            :width="map.width"
            xmlns="http://www.w3.org/2000/svg"
            @contextmenu.prevent="($event) => startLine($event, map.cmPerPixel, mapIndex)"
            @click.prevent="($event) => finishLine($event, map.cmPerPixel)"
            @mousemove="($event) => moveLine($event, map.cmPerPixel)"
          >
            <foreignObject :height="map.height" :width="map.width">
              <map :id="map.id" :name="map.id">
                <area
                  v-for="area in map.areas"
                  :key="area.id"
                  :data-ref="area.id"
                  :shape="area.shape"
                  :coords="area.coords"
                  @mouseover="($event) => areaMouseOver($event, map.cmPerPixel)"
                  @mousemove="areaMouseMove"
                  @mouseleave="areaMouseLeave"
                />
              </map>
              <div class="map-bottom">
                <canvas
                  v-for="image in map.mapsImages"
                  :key="image.id"
                  :id="image.id"
                  :data-area="image.areaInPixels"
                  class="area"
                />
              </div>
              <div
                class="map-top"
              >
                <img :src="map.mainImgSrc" :usemap="'#' + map.id" :width="map.width" :height="map.height" />
              </div>
            </foreignObject>
          </svg>
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiSend } from '@mdi/js'
export default {
  data () {
    return {
      mdiSend,
      url: null,
      loading: false,
      svgActive: false,
      worker: null,
      maps: []
    }
  },
  mounted () {
    this.worker = new Worker('area-worker.js')
    this.worker.onmessage = this.getMessagesFromWorker
  },
  methods: {
    getMessagesFromWorker (event) {
      if (event.data.status === 'complite') {
        const { areaInPixels, mapIndex, imageIndex } = event.data
        const array = [...this.maps[mapIndex].mapsImages]
        array[imageIndex].areaInPixels = areaInPixels

        this.$set(this.maps, mapIndex, { ...this.maps[mapIndex], mapsImages: array })
      }
    },
    send () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          this.loading = true
          try {
            const { data } = await this.$axios.post('/api/maps-url', {
              url: this.url
            })
            this.maps = data
            setTimeout(() => {
              this.drawCanvas()
            }, 0)
            this.loading = false
          } catch (err) {
            this.loading = false
            this.$toasted.error(err.response.data.message)
          }
        }
      })
    },
    drawCanvas () {
      this.maps.forEach((map, mapIndex) => {
        map.mapsImages.forEach((image, imageIndex) => {
          const canvas = document.getElementById(image.id)
          canvas.width = map.width.replace('px', '')
          canvas.height = map.height.replace('px', '')
          const ctx = canvas.getContext('2d')
          const img = new Image
          img.onload = () => {
            ctx.drawImage(img,0,0)

            this.worker.postMessage({
              imageData: ctx.getImageData(0, 0, canvas.width, canvas.height),
              width: canvas.width,
              height: canvas.height,
              mapIndex,
              imageIndex
            })
          }
          img.src = image.src
          img.setAttribute('crossOrigin', '')
        })
      })

    },
    areaMouseOver ($event, cmPerPixel) {
      const tooltips = document.getElementsByClassName('tooltip')
      while (tooltips.length) {
        tooltips[tooltips.length - 1].remove()
      }

      const target = $event.target
      const offsetParent = target.offsetParent
      const tooltip = document.createElement('div')
      offsetParent.append(tooltip)

      const canvasId = target.dataset.ref
      const canvas = document.getElementById(canvasId)
      canvas.style.opacity = 1

      tooltip.classList.add('tooltip')
      tooltip.innerHTML = 'Area: ' + this.getSingAreanInMeters(canvas.dataset.area, cmPerPixel) + 'm<sup>2</sup>'

      if ($event.offsetX - (tooltip.clientWidth / 2) > offsetParent.clientWidth) {
        tooltip.style.left = $event.offsetX + (tooltip.clientWidth / 2) + 'px'
      } else {
        tooltip.style.left = $event.offsetX - (tooltip.clientWidth / 2) + 'px'
      }

      if ($event.offsetY + (tooltip.clientWidth / 2) > offsetParent.clientHeight) {
        tooltip.style.top = $event.offsetY - tooltip.clientHeight - 10 + 'px'
      } else {
        tooltip.style.top = $event.offsetY + (tooltip.clientHeight / 2) + 'px'
      }
    },
    areaMouseMove ($event) {
      const tooltips = document.getElementsByClassName('tooltip')
      const tooltip = tooltips[0]
      const offsetParent = tooltip.offsetParent

      if ($event.offsetX - (tooltip.clientWidth / 2) > offsetParent.clientWidth) {
        tooltip.style.left = $event.offsetX + (tooltip.clientWidth / 2) + 'px'
      } else {
        tooltip.style.left = $event.offsetX - (tooltip.clientWidth / 2) + 'px'
      }

      if ($event.offsetY + (tooltip.clientWidth / 2) > offsetParent.clientHeight) {
        tooltip.style.top = $event.offsetY - tooltip.clientHeight - 10 + 'px'
      } else {
        tooltip.style.top = $event.offsetY + (tooltip.clientHeight / 2) + 'px'
      }
    },
    areaMouseLeave ($event) {
      const tooltips = document.getElementsByClassName('tooltip')
      while (tooltips.length) {
        tooltips[tooltips.length - 1].remove()
      }
      const target = $event.target
      const canvasId = target.dataset.ref
      const canvas = document.getElementById(canvasId)
      canvas.style.opacity = 0.6
    },
    getSingAreanInMeters (area, cmPerPixel) {
      return Math.round((cmPerPixel / 100) * (cmPerPixel / 100) * area)
    },
    getAreaInMeters (map) {
      return Math.round((map.cmPerPixel / 100) * (map.cmPerPixel / 100) * this.getArea(map.mapsImages))
    },
    getArea (areas) {
      return areas.reduce((all, val) => all + (val.areaInPixels || 0), 0)
    },
    startLine ($event, cmPerPixel, mapIndex) {
      let svgContainer = $event.target
      while (svgContainer.nodeName !== 'svg') {
        svgContainer = svgContainer.parentElement
      }

      const scaleElements = svgContainer.getElementsByClassName('scale-element')
      while (scaleElements.length) {
        scaleElements[scaleElements.length - 1].remove()
      }

      const startPoint = document.createElementNS('http://www.w3.org/2000/svg','circle')
      startPoint.setAttribute('id', 'startPoint')
      startPoint.setAttribute('cx', $event.layerX)
      startPoint.setAttribute('cy', $event.layerY)
      startPoint.setAttribute('r', 3)
      startPoint.setAttribute('fill', 'white')
      startPoint.classList.add('scale-element')

      const line = document.createElementNS('http://www.w3.org/2000/svg','line')
      line.setAttribute('id', 'line')
      line.setAttribute('x1', $event.layerX)
      line.setAttribute('x2', $event.layerX)
      line.setAttribute('y1', $event.layerY)
      line.setAttribute('y2', $event.layerY)
      line.setAttribute('stroke', 'white')
      line.setAttribute('fill', 'transparent')
      line.setAttribute('stroke-dasharray', '3 3')
      line.setAttribute('stroke-width', 2)
      line.classList.add('scale-element')

      const text = document.createElementNS('http://www.w3.org/2000/svg','text')
      text.setAttribute('id', 'text')
      text.setAttribute('text-anchor', 'middle')
      text.setAttribute('alignment-baseline', 'middle')
      text.setAttribute('x', $event.layerX)
      text.setAttribute('y', $event.layerY)
      text.setAttribute('fill', 'orange')
      text.classList.add('scale-element')
      text.textContent = '0m'
      text.onclick = ($event) => {
        if (this.svgActive) return
        $event.preventDefault()
        $event.stopPropagation()
        const foreignObject = document.createElementNS('http://www.w3.org/2000/svg','foreignObject')
        foreignObject.setAttribute('id', 'input')
        foreignObject.setAttribute('x', parseInt(text.getAttribute('x')) - 25)
        foreignObject.setAttribute('y', parseInt(text.getAttribute('y')) - 11)
        foreignObject.setAttribute('height', 22)
        foreignObject.setAttribute('width', 50)

        const input = document.createElement('input')
        input.type = 'text'

        const pixels = Math.round(Math.sqrt(
          Math.pow(parseInt(line.getAttribute('x2')) - parseInt(line.getAttribute('x1')), 2) +
          Math.pow(parseInt(line.getAttribute('y2')) - parseInt(line.getAttribute('y1')), 2)
        ))

        input.value = (pixels * (this.maps[mapIndex].cmPerPixel / 100)).toFixed(1)
        input.style.width = '50px'
        input.style.backgroundColor = 'white'
        input.style.color = 'black'
        input.style.padding = '2px'
        input.style.outline = 'none'
        input.onclick = ($event) => {
          $event.stopPropagation()
        }
        input.oninput = () => {
          const number = Number(input.value)
          if (typeof number === 'number') {
            const pixels = Math.round(Math.sqrt(
              Math.pow(parseInt(line.getAttribute('x2')) - parseInt(line.getAttribute('x1')), 2) +
              Math.pow(parseInt(line.getAttribute('y2')) - parseInt(line.getAttribute('y1')), 2)
            ))

            const cmPerPixel = Math.round(number * 100 / pixels)
            this.$set(this.maps, mapIndex, { ...this.maps[mapIndex], cmPerPixel })
          }
        }
        input.onkeyup = ($event) => {
          if ($event.key === 'Enter') {
            const number = Number(input.value)
            if (typeof number === 'number') {
              const pixels = Math.round(Math.sqrt(
                Math.pow(parseInt(line.getAttribute('x2')) - parseInt(line.getAttribute('x1')), 2) +
                Math.pow(parseInt(line.getAttribute('y2')) - parseInt(line.getAttribute('y1')), 2)
              ))

              const cmPerPixel = Math.round(number * 100 / pixels)
              this.$set(this.maps, mapIndex, { ...this.maps[mapIndex], cmPerPixel })
            }

            this.removeInput($event, this.maps[mapIndex].cmPerPixel)
          }
        }
        foreignObject.append(input)
        svgContainer.append(foreignObject)
      }

      svgContainer.append(startPoint)
      svgContainer.append(line)
      svgContainer.append(text)
      this.svgActive = true
    },
    moveLine ($event, cmPerPixel) {
      if (this.svgActive) {
        let svgContainer = $event.target
        while (svgContainer.nodeName !== 'svg') {
          svgContainer = svgContainer.parentElement
        }

        const line = svgContainer.getElementById('line')
        line.setAttribute('x2', $event.layerX)
        line.setAttribute('y2', $event.layerY)

        const text = svgContainer.getElementById('text')
        text.setAttribute('x', (parseInt(line.getAttribute('x1')) + $event.layerX) / 2)
        text.setAttribute('y', (parseInt(line.getAttribute('y1')) + $event.layerY) / 2)

        const pixels = Math.round(Math.sqrt(
          Math.pow(parseInt(line.getAttribute('x2')) - parseInt(line.getAttribute('x1')), 2) +
          Math.pow(parseInt(line.getAttribute('y2')) - parseInt(line.getAttribute('y1')), 2)
        ))
        text.textContent = (pixels * (cmPerPixel / 100)).toFixed(1) + 'm'
      }
    },
    finishLine ($event, cmPerPixel) {
      let svgContainer = $event.target
      while (svgContainer.nodeName !== 'svg') {
        svgContainer = svgContainer.parentElement
      }

      this.removeInput($event, cmPerPixel)
      if (this.svgActive) {
        const line = svgContainer.getElementById('line')
        line.setAttribute('x2', $event.layerX)
        line.setAttribute('y2', $event.layerY)

        const text = svgContainer.getElementById('text')
        text.setAttribute('x', (parseInt(line.getAttribute('x1')) + $event.layerX) / 2)
        text.setAttribute('y', (parseInt(line.getAttribute('y1')) + $event.layerY) / 2)

        const pixels = Math.round(Math.sqrt(
          Math.pow($event.layerX - parseInt(line.getAttribute('x1')), 2) +
          Math.pow($event.layerY - parseInt(line.getAttribute('y1')), 2)
        ))
        text.textContent = (pixels * (cmPerPixel / 100)).toFixed(1) + 'm'

        const finishPoint = document.createElementNS('http://www.w3.org/2000/svg','circle')
        finishPoint.setAttribute('id', 'finishPoint')
        finishPoint.setAttribute('cx', $event.layerX)
        finishPoint.setAttribute('cy', $event.layerY)
        finishPoint.setAttribute('r', 3)
        finishPoint.setAttribute('fill', 'white')
        finishPoint.classList.add('scale-element')

        svgContainer.append(finishPoint)
        this.svgActive = false
      }
    },
    removeInput ($event, cmPerPixel) {
      let svgContainer = $event.target
      while (svgContainer.nodeName !== 'svg') {
        svgContainer = svgContainer.parentElement
      }

      const foreignObject = svgContainer.getElementById('input')
      if (foreignObject) {
        foreignObject.remove()

        const line = svgContainer.getElementById('line')
        const text = svgContainer.getElementById('text')
        const pixels = Math.round(Math.sqrt(
          Math.pow(parseInt(line.getAttribute('x2')) - parseInt(line.getAttribute('x1')), 2) +
          Math.pow(parseInt(line.getAttribute('y2')) - parseInt(line.getAttribute('y1')), 2)
        ))
        text.textContent = (pixels * (cmPerPixel / 100)).toFixed(1) + 'm'
      }
    }
  }
}
</script>

<style scoped>
  .map {
    position: relative;
    overflow-x: auto;
  }

  .map-top {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  .map-top img {
    display: block;
    margin: 0 auto;
  }
  .area {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    opacity: 0.6;
  }

  .map >>> .tooltip {
    color: black;
    position: absolute;
    display: inline-block;
    background-color: white;
    border-radius: 5px;
    z-index: 3;
    padding: 8px;
  }

  .map svg {
    left: 0;
    right: 0;
    margin: 0 auto;
    position: absolute;
    z-index: 2;
  }

  svg >>> text {
    font-weight: bold;
    cursor: pointer;
  }
</style>